import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";

import EditUploadDocument from "../../../../../Documents/EditUploadDocument";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

import useDocumentUploadState from "./hooks/useDocumentUploadState";
import StaticSelectAnswer from "./StaticSelectAnswer";
import { addButtonStyles, staticSelectStyles } from "./styles/DocumentUpload";

const DocumentUpload = ({
  buttonLabel = "Upload Document",
  data,
  handleAnswerChange,
  hasDisposition = false,
  label,
  preAuthUrl,
  questionKey,
  schema = null,
}) => {
  const {
    dispositionOpts,
    handleDispositionChange,
    handleSubmit,
    openModal,
    selectedDisposition,
    selectedDocument,
    setOpenModal,
  } = useDocumentUploadState({
    data,
    handleAnswerChange,
    hasDisposition,
    preAuthUrl,
    questionKey,
    schema,
  });

  return (
    <>
      <div
        className="grid items-end justify-between w-full gap-2 mb-4"
        style={{
          gridTemplateColumns: hasDisposition ? "70% auto" : "1fr",
        }}
      >
        {hasDisposition ? (
          <StaticSelectAnswer
            allowClear
            boxMarginBottom={2}
            label={label}
            name="pdSeverity"
            options={dispositionOpts}
            onChange={(_, value) => handleDispositionChange(value)}
            schema={null}
            value={selectedDisposition || null}
            placeholder="Select an Option"
            sx={staticSelectStyles}
          />
        ) : (
          <QuestionTitle label={label} sx={sharedStyles.label(false)} />
        )}
        <Button
          sx={addButtonStyles(hasDisposition)}
          className="py-2 pl-8 pr-2 text-xs normal-case bg-white w-52 rounded-3xl"
          variant="outlined"
          onClick={() => setOpenModal(true)}
        >
          {buttonLabel}
          <AddCircleOutline fontSize="small" className="ml-auto" />
        </Button>
      </div>

      <EditUploadDocument
        disableForm
        externalOnSubmit={handleSubmit}
        initialSelectedDocument={hasDisposition ? data?.document || null : data || null}
        isFormModule
        onClose={() => setOpenModal(false)}
        open={openModal}
        selectedDocument={selectedDocument}
        title="Add Document"
      />
    </>
  );
};

export default DocumentUpload;
